import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function libraryBrandStart({ currentOutlet }) {
  pushClevertapEvent('Library Brand Start', {
    'Current Selected Outlet': currentOutlet,
  });
}

export function libraryBrandChangeOutlet({ previousOutlet, currentOutlet }) {
  pushClevertapEvent('Library Brand Change Outlet', {
    'Previous Selected Outlet': previousOutlet,
    'Current Selected Outlet': currentOutlet,
  });
}

export function libraryBrandCreate({ brand, allOutlet }) {
  const eventName = allOutlet
    ? 'Library Brand Create All Outlet'
    : 'Library Brand Create One Outlet';
  pushClevertapEvent(eventName, {
    Name: brand.name,
  });
}

export function libraryBrandUpdateOneOutlet({ oldName, newName }) {
  pushClevertapEvent('Library Brand Update One Outlet', {
    'Old Name': oldName,
    'New Name': newName,
  });
}

export function libraryBrandAssignToItems({ name, itemNames }) {
  pushClevertapEvent('Library Brand Assign To Items', {
    Name: name,
    'Item Names': itemNames,
  });
}

export function libraryBrandDelete({ name }) {
  pushClevertapEvent('Library Brand Delete', {
    Name: name,
  });
}
